export default {
  outages: {
    title: 'Nedostupnosť služieb',
    topDescription: 'Na nasledujúcich službách bude prebiehať plánovaná údržba siete:',
    bottomDescription:
      'Mrzí nás obmedzenie vašich služieb, ale aj týmto krokom pracujeme na ich vylepšení.',
    duration: '<br>v\xa0trvaní [DURATION]',
    durationFormat: duration => {
      const hours = Math.floor(duration / 60);
      const minutes = duration % 60;
      const hoursString = (() => {
        if (hours === 0) {
          return '';
        }
        if (hours === 1) {
          return `${hours}\xa0hodiny`;
        }
        return `${hours}\xa0hodín`;
      })();
      const minutesString = (() => {
        if (minutes === 0) {
          return '';
        }
        if (minutes === 1) {
          return `${minutes}\xa0minúty`;
        }
        return `${minutes}\xa0minút`;
      })();
      return `${hoursString}${hours && minutes ? ', ' : ''}${minutesString}`;
    },
    sameDayInterval: 'Dňa <b>[DATE]</b> medzi <b>[START_TIME]</b> a&nbsp;<b>[END_TIME]</b>',
    multiDayInterval: 'Medzi <b>[START_DATE_TIME]</b> a&nbsp;<b>[END_DATE_TIME]</b>',
    imageAltText: 'Muž pracujúci pred obrazovkou s chybou',
    buttons: {
      learnMore: 'Zistiť viac',
      understood: 'Rozumiem',
    },
  },
};
